import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import useGetUserProfile from '../../../../common/category/useGetUserProfile'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { PanelContainer } from '../../../../common/panel/PanelContainer'
import { BackButton } from './BackButton'
import { CancelBtn } from './CancelBtn'
import './i18n'
import classes from './index.module.scss'
import { OrderDetails } from './orderDetails'
import { OrderInformation } from './orderInformation'
import Pdf from './pdf'
import { selectData } from './store/slice'
import { getDetailOrderThunk } from './store/thunk'

export const OrderDetail = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { loading } = useGetUserProfile()
  const data = useSelector(selectData)
  const locale = useSelector((state) => state.i18n.locale)

  const { orderId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(getDetailOrderThunk({ Id: orderId }))
  }, [locale])

  if (loading) return <Loading />

  return (
    <Element className={classes.container}>
      <BackButton />
      <Element className={classes.title} style={{ fontSize: 20 }}>
        <Translate value="userManagement.orderManagement.orderDetail.DETAIL_ORDER" />
      </Element>
      <div className={classes.panel}>
        <PanelContainer>
          <OrderInformation />
          <OrderDetails />
        </PanelContainer>
      </div>
      <div
        className="flexRow justifyContentEnd mt2"
        style={{ paddingBottom: 20 }}
      >
        <CancelBtn
          orderId={orderId}
          requestedToCancel={data?.requestedToCancel || false}
          orderStatus={data?.status}
        />
        <Pdf />
      </div>
    </Element>
  )
}
